import axios from 'axios'
import { baseURL } from './config.js'
import qs from 'qs'
import cookie from "js-cookie";

export default {
  setProduct(params) { //企业用户分配产品
    const url =  baseURL + '/tbAuthorizedproduct/companyProductDistribute';
    return axios.post(url, qs.stringify(params));
  },
  userList(params) { // 用户列表
    const url =  baseURL + '/tbUser/userListFront';
    return axios.post(url, qs.stringify(params));
  },
  delComUserList(params) { // 批量删除企业用户
    const url =  baseURL + '/tbUser/companyManagerRemoveUser';
    return axios.post(url, qs.stringify(params));
  },
  
  delProduct(params) { //企业用户分配产品 撤销
    const url =  baseURL + '/tbAuthorizedproduct/companyProductDistributeCancel';
    return axios.post(url, qs.stringify(params));
  },
  
  // 撤销分配产品给部门
  delProductDepart(params) { 
    const url =  baseURL + '/tbDept/deptProductCancle';
    return axios.post(url, qs.stringify(params));
  },


  getList(params) { //获取授权产品列表
    const url =  baseURL + '/tbAuthorizedproduct/getList';
    return axios.post(url, qs.stringify(params));
  },
  accountDetail(params) { //我的账户详情
    const url =  baseURL + '/tbUser/getDetail';
    return axios.post(url, qs.stringify(params));
  },
  

  addComList(params) { // 企业用户拉人
    const url =  baseURL + '/tbUser/companyManagerAddUser';
    return axios.post(url, qs.stringify(params));
  },

  getSBList(params) { // 获取设备列表
    const url =  baseURL + '/tbComputermanage/list';
    return axios.post(url, qs.stringify(params));
  },
  addSBList(params) { // 添加设备
    const url =  baseURL + '/tbComputermanage/modify';
    return axios.post(url, qs.stringify(params));
  },
  delSBList(params) { // 删除设备
    const url =  baseURL + '/tbComputermanage/delete';
    return axios.post(url, qs.stringify(params));
  },

  addComUserList(params) { // 管理员拉人
    const url =  baseURL + '/tbUser/adminUserAddUsers';
    return axios.post(url, qs.stringify(params));
  },

  companyProductBatchDistribute(params) { // 批量分配产品
    const url =  baseURL + '/tbAuthorizedproduct/companyProductBatchDistribute';
    return axios.post(url, qs.stringify(params));
  },
  
  companyBatchAdd(params) { // 企业设备导入
    const url =  baseURL + '/tbComputermanage/batchAdd';
    return url;
  },
  
  companyTemplate(params) { // 企业设备导入模板
    const url =  baseURL + '/tbComputermanage/template'+'?checkCode='+ cookie.get("dnnyptadmin_checkCode")+'&token='+ cookie.get("dnnyptadmin_token");
    return url;
  },



  /**部门管理 **/
  
  // 查询部分下人员
  getCompanyUser(params) { 
    const url =  baseURL + '/tbUser/getCompanyUser';
    return axios.post(url, qs.stringify(params));
  }, 
  
  // 查询部门列表
  getDepartList(params) { 
    const url =  baseURL + '/tbDept/deptList';
    return axios.post(url, qs.stringify(params));
  }, 

  // 查询部门详情
  getDepartDetail(params) { 
    const url =  baseURL + '/tbDept/deptDetail';
    return axios.post(url, qs.stringify(params));
  }, 
 
  // 新增
  addDept(params) { 
    const url =  baseURL + '/tbDept/addDept';
    // return axios.post(url, params);
    return axios.post(url, qs.stringify(params));
  }, 

  // 编辑
  editDept(params) { 
    const url =  baseURL + '/tbDept/modifyDept';
    // return axios.post(url,params);
    return axios.post(url, qs.stringify(params));
  }, 

  // 删除部门
  delDepart(params) { 
    const url =  baseURL + '/tbDept/deptDelete';
    return axios.post(url, qs.stringify(params));
  }, 

  // 根据用户id获取部门列表
  getDeptListByUserId(params){
    const url =  baseURL + '/tbDept/getDeptIdByUserId';
    return axios.post(url, qs.stringify(params));
  },


  // 产品分配给部门
  dispatchProductToDepart(params){
    const url =  baseURL + '/tbAuthorizedproduct/auProToDeptManager';
    return axios.post(url, qs.stringify(params));
  },

   // 校验部门名称是否唯一
   checkDepartUnique(param) {
    const url = baseURL + '/tbDept/deptNameCheck?deptname='+ param.deptname +'&companyid='+param.companyid;
    return axios.post(url)
  },


  

  /**跟踪记录 **/

  // 跟踪记录分页
  getTrackList(params) { 
    const url =  baseURL + '/enterprise/loadRatio/marketPicturePage';
    return axios.post(url, qs.stringify(params));
  }, 
  
  // 新增
  addTrack(params) { 
    const url =  baseURL + '/enterprise/loadRatio/marketPicture';
    // return axios.post(url, params);
    return axios.post(url, qs.stringify(params));
  }, 
  
  // 更新： del = 0,删除操作
  updateTrack(params) { 
    const url =  baseURL + '/enterprise/loadRatio/marketPictureUpdate';
    // return axios.post(url, params);
    return axios.post(url, qs.stringify(params));
  }, 
  

  // 上传现场照片
  uploadPic(params) { 
    const url =  baseURL + '/tbPic/setPic';
    return axios({
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      url,
      method: 'post',
      data: params
    });
  }, 
  
  // 删除现场照片
  delPic(params) { 
    const url =  baseURL + '/enterprise/loadRatio/delPic';
    return axios.post(url, params);
  }, 

  // 2023-12-12 wuliang add 评论
  // 获取评论列表
  getComment(marketid) {
    const url = baseURL + "/tbMarketComment/list?marketid=" + marketid;
    return axios.get(url);
  },
  // 新增评论
  addComment(param) {
    const url = baseURL + "/tbMarketComment/modify?mode=save&marketid=" + param.marketid+'&userid='+param.userid+'&note='+param.note;
    return axios.post(url);
  },
  // 删除评论
  delComment(id) {
    const url = baseURL + "/tbMarketComment/delete?id=" + id;
    return axios.post(url);
  },
}


// WEBPACK FOOTER //
// ./src/api/userCom.js